import React, { useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import AppointmentCreateWithNotExistUser from './AppointmentCreateWithNotExistUser';
import AppointmentCreateWithExistUser from './AppointmentCreateWithExistUser';
import { GetAppointmentGroupDetailsOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels';
import '../../../../style.css'

type Props = {appointmentDetail: GetAppointmentGroupDetailsOutput}

const AppointmentCreateForGrouppedData: React.FC<Props> = ({ appointmentDetail }) => {

    const handleAppointmentTypeSubmit = () => {
        if (createWithExistingUser) {
            // Var olan danışan için randevu oluştur popup'ını aç
            setShowExistingUserModal(true);
        } else if (createWithNewUser) {
            // Yeni bir danışan için randevu oluştur popup'ını aç
            setShowNewUserModal(true);
        }
        // Diğer durumlar için gerekli işlemleri buraya ekleyebilirsiniz
    };

    const closeAppointmentTypeModal = () => {
        setShowAppointmentTypeModal(false);
    };

    const openAppointmentTypeModal = () => {
        setShowAppointmentTypeModal(true);
    };

    const [showAppointmentTypeModal, setShowAppointmentTypeModal] = useState(false);
    const [showExistingUserModal, setShowExistingUserModal] = useState(false); // Yeni eklendi
    const [showNewUserModal, setShowNewUserModal] = useState(false); // Yeni eklendi
    const [createWithExistingUser, setCreateWithExistingUser] = useState(false);
    const [createWithNewUser, setCreateWithNewUser] = useState(false);

    return (
        <>
            <div className="w-100 btn btn-darken p-4" style={{backgroundColor:"#A5D6A7"}} onClick={() => openAppointmentTypeModal()}>
                <div className='d-flex justify-content-center item-align-center fw-bold w-100'>
                    {appointmentDetail.appointmentStartHour < 10 ? ("0" + appointmentDetail.appointmentStartHour.toString()) : appointmentDetail.appointmentStartHour}
                    :
                    {appointmentDetail.appointmentStartMunite < 10 ? ("0" + appointmentDetail.appointmentStartMunite.toString()) : appointmentDetail.appointmentStartMunite} (BOŞ)
                </div>
                <div className="text-gray-700 fw-bold fs-7 pt-1"><br/></div>
            </div>
            <Modal show={showAppointmentTypeModal} onHide={closeAppointmentTypeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Hangi Tipte Randevu Oluşturmak İstersiniz?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAppointmentTypeSubmit}>
                        <Row className="mb-3 text-gray-900">
                            <Form.Group as={Col}>
                                <Form.Check
                                        type="checkbox"
                                        id="createWithExistingUser"
                                        label="Sistemde kayıtlı bir danışan için randevu oluştur."
                                        name="createWithExistingUser"
                                        checked={createWithExistingUser}
                                        onChange={() => {
                                            setCreateWithExistingUser(true);
                                            setCreateWithNewUser(false);
                                        }}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Check
                                        type="checkbox"
                                        id="createWithNewUser"
                                        label="Yeni bir danışan için randevu oluştur."
                                        name="createWithNewUser"
                                        checked={createWithNewUser}
                                        onChange={() => {
                                            setCreateWithExistingUser(false);
                                            setCreateWithNewUser(true);
                                        }}
                                    />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeAppointmentTypeModal}>
                        Kapat
                    </Button>
                    {createWithExistingUser ? <AppointmentCreateWithExistUser propAppointmentStartDate={new Date(appointmentDetail.appointmentStartDate)}/> : 
                                              <AppointmentCreateWithNotExistUser propAppointmentStartDate={new Date(appointmentDetail.appointmentStartDate)}/>}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default (AppointmentCreateForGrouppedData)